var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResetModal',{attrs:{"header":"You are about to Infinity","message":_vm.message,"gained-resources":_vm.ipGainInfo,"starting-resources":_vm.startingResources,"confirm-fn":_vm.handleYesClick,"alternate-condition":_vm.isFirstInfinity,"alternate-text":_vm.message,"confirm-option":_vm.isFirstInfinity ? undefined : 'bigCrunch'}})
}
var staticRenderFns = []

export { render, staticRenderFns }